import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import translatedCountries from "./translated-countries.json"
import supportedCountries from "./supported-countries.json"
import { CommonModule } from "@angular/common";
import { ValidationService } from "@app/core/services/validationService";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    templateUrl: './phone-input.component.html',
    selector: 'my-phone',
    styleUrls: ['./phone-input.component.css'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, CommonModule, TranslateModule]
})
export class PhoneComponent implements OnInit {
    @Input("formGroup") phoneFormGroup: FormGroup;

   // public phoneInput: intlTelInput.Plugin;
    ngOnInit(): void {
        // const input = document.querySelector("#phoneElement");
        // this.phoneInput = intlTelInput(input, {
        //     autoPlaceholder: 'off',
        //     localizedCountries: translatedCountries,
        //     onlyCountries: supportedCountries,
        //     preferredCountries: [],
        //     formatOnDisplay:false,
        //     initialCountry:"auto",
        //     utilsScript: "intl-tel-input/build/js/utils.js"
        // });

        // setTimeout(() => {
        //     if(this.phone.valid)
        //     this.phoneInput.setNumber(this.phone.value);
        // }, 200);
    }

    constructor(public validationService: ValidationService) { }

    onInputChanged() {
        // const isValid = this.phoneInput.isValidNumber();

        // // if the number is invalid and there isn't an existing error
        // if (!isValid && !this.phone.hasError('phoneNumberInvalid')) {
        //     this.phone.setErrors({ 'phoneNumberInvalid': true });
        // }
        // // if the number is valid and there's an existing error
        // else if (isValid && this.phone.hasError('phoneNumberInvalid')) {
        //     const remainingErrors = { ...this.phone.errors };
        //     delete remainingErrors['phoneNumberInvalid'];
        //     this.phone.setErrors(Object.keys(remainingErrors).length > 0 ? remainingErrors : null);
        // }
    }

    get phone() { return this.phoneFormGroup.get("phone") };
    get isValid() { return this.phoneFormGroup.get("phone").valid };

}